<script>
	import DataBlock from "./DataBlock.svelte";
	import Header from "./components/Header/Header.svelte";
	import { boot } from "../scripts/eth.js";
	import { onMount } from 'svelte';

	onMount(boot);

</script>

<body background="images/airdropBackground.svg">
	<Header/>
	<main>
		<h1>IRO Rewards Dashboard</h1>
		<p class="boldRed" style="margin: 0px 20px 20px;"> Disclaimer: IRO Rewards will be distributed only if the IRO is successful.</p>
		<p style="margin: 0px 20px 20px;"> This data is not live, and updates periodically. <a href="https://docs.citadao.io/intro/how-iro-works/introducing-real-estate-on-chain/iro-rewards">How is APR calculated?</a></p>

		<DataBlock/>
	</main>
	
</body>


<svelte:head>
	<link href='https://fonts.googleapis.com/css?family=Montserrat:400,700' rel='stylesheet'>
</svelte:head>

<style>
	main {
		/* text-align: center; */
		padding: 1em;

		/* margin: 20px auto; */

		
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		
	}

	body {
		width: auto;
		height: auto;
		min-height: 100vh;
		background-repeat: no-repeat;
		background-size: cover;
		background-attachment: fixed;

	}

	h1 {
		font-family: Montserrat;
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		line-height: 52px;

		margin: 20px;
	}

	a {
		font-family: Montserrat;
		font-style: normal;
		font-size: 18px;
	}
	
	p {
		font-family: Montserrat;
		font-style: normal;
		font-size: 18px;
	}

	.boldRed {
		font-weight: 700;
		color: red;
	}
</style>